<ng-container *ngIf="!isLoaded; else displayContent">
  <lib-ags-loading></lib-ags-loading>
</ng-container>

<ng-template #displayContent>
  <ng-container *ngIf="!errorPage; else displayErrorPage">
    <div class="uk-grid uk-margin-remove-left">
      <div class="uk-width-1-1 uk-margin-remove uk-padding-remove">
        <div class="uk-card uk-card-default">
          <div class="uk-card-header uk-padding-small" [ngClass]="[headerBackground]">
            <div class="uk-grid-small uk-flex-middle uk-flex">
              <div>
                <h3 class="uk-card-title uk-margin-remove-button uk-margin-remove-bottom" [ngClass]="[headerColor]">
                  Proposition
                </h3>
                <p class="uk-text-meta uk-margin-remove-top uk-margin-remove-bottom" [ngClass]="[headerColor]">
                  <ng-container *ngIf="demandeDetail.dateCreation">
                    Survenue le {{ demandeDetail.dateCreation }}
                  </ng-container>
                  <ng-container *ngIf="demandeDetail.dateValid">
                    valable jusqu'au {{ demandeDetail.dateValid }}
                  </ng-container>
                  &nbsp;
                  <span class="primary-background-darker argalis-badge">
                    {{ demandeDetail.referenceProduit }}
                  </span>
                </p>
              </div>
              <div style="text-align: right; margin-left: auto">
                <button
                  kendoButton
                  class="primary-background"
                  (click)="goBack()"
                  uk-tooltip="Page précédente"
                  [ngClass]="[headerColor]"
                >
                  <span uk-icon="icon: arrow-left"></span>
                </button>
              </div>
            </div>
          </div>
          <ng-container *ngIf="!demandeDetail.alreadyProcessed; else displayAlreadyProcessed">
            <div class="uk-width-1-1 uk-padding-small uk-background-muted primary-color">
              {{ demandeDetail.remainingDay }}
              &nbsp;
              <ng-container *ngIf="demandeDetail.urlAccept && demandeDetail.urlRefuse">
                <button
                  kendoButton
                  [primary]="false"
                  class="colored-text uk-text-uppercase button-grey-light"
                  (click)="refuse()"
                >
                  <span uk-icon="close"></span>&nbsp;Je décline
                </button>
                &nbsp;
                <button
                  kendoButton
                  [primary]="true"
                  class="colored-text primary-background uk-text-uppercase"
                  (click)="accept()"
                >
                  <span uk-icon="check"></span>&nbsp;J'accepte
                </button>
              </ng-container>
            </div>
          </ng-container>
          <ng-template #displayAlreadyProcessed>
            <!--<div class="uk-width-1-1 uk-padding-small uk-background-muted primary-color">-->
            <!--Vous avez validé vos dates pour cette proposition.-->
            <!--</div>-->
          </ng-template>
          <div class="uk-card-body uk-padding">
            <table class="uk-table">
              <tbody>
                <tr>
                  <td class="uk-width-small uk-padding-remove uk-text-meta" style="vertical-align: middle">Produit</td>
                  <td class="uk-table-expand uk-padding-remove" style="vertical-align: middle">
                    {{ demandeDetail.title || 'Titre non trouvé' }}
                  </td>
                </tr>
                <tr>
                  <td class="uk-width-small uk-padding-remove uk-text-meta" style="vertical-align: middle">
                    Code produit
                  </td>
                  <td class="uk-table-expand uk-padding-remove" style="vertical-align: middle">
                    {{ demandeDetail.referenceProduit || 'Référence produit non trouvée' }}
                  </td>
                </tr>
                <tr>
                  <td class="uk-width-small uk-padding-remove uk-text-meta" style="vertical-align: middle">
                    N° Session
                  </td>
                  <td class="uk-table-expand uk-padding-remove" style="vertical-align: middle">
                    {{ demandeDetail.referenceSession || 'Référence session non trouvée' }}
                  </td>
                </tr>
                <tr>
                  <td class="uk-width-small uk-padding-remove uk-text-meta" style="vertical-align: middle">
                    Référence interne
                  </td>
                  <td class="uk-table-expand uk-padding-remove" style="vertical-align: middle">
                    {{ demandeDetail.referenceInterne || 'Référence interne non trouvée' }}
                  </td>
                </tr>
                <tr>
                  <td class="uk-width-small uk-padding-remove uk-text-meta" style="vertical-align: middle">Modalité</td>
                  <td class="uk-table-expand uk-padding-remove" style="vertical-align: middle">
                    {{ demandeDetail.modalite || 'Modalité non trouvée' }}
                  </td>
                </tr>
                <tr>
                  <td class="uk-width-small uk-padding-remove uk-text-meta" style="vertical-align: middle">Durée</td>
                  <td class="uk-table-expand uk-padding-remove" style="vertical-align: middle">
                    {{ demandeDetail.duration || 'Durée restante non trouvée' }}
                  </td>
                </tr>
                <tr>
                  <td class="uk-width-small uk-padding-remove uk-text-meta" style="vertical-align: middle">
                    Lieu principal
                  </td>
                  <td class="uk-table-expand uk-padding-remove" style="vertical-align: middle">
                    {{ demandeDetail.lieuName || ' ' }}
                    <ng-container *ngIf="demandeDetail.lieuAddress"><br /></ng-container>
                    {{ demandeDetail.lieuAddress || ' ' }}
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="uk-card uk-card-default">
              <div class="uk-card-header uk-padding-small uk-background-muted">
                <div class="uk-width-expand">
                  <h3 class="uk-card-title uk-margin-remove-bottom uk-text-meta uk-text-uppercase uk-text-muted">
                    Responsable administratif
                  </h3>
                </div>
              </div>
              <div class="uk-card-body">
                <div class="uk-grid uk-flex-middle">
                  <div class="uk-width-auto">
                    <img
                      [src]="demandeDetail.photoResponsible"
                      alt="Responsable"
                      width="100"
                      class="uk-border-circle"
                    />
                  </div>
                  <div class="uk-width-expand">
                    <p>
                      {{ demandeDetail.nameResponsible || 'Nom non trouvé' }}<br />
                      {{ demandeDetail.emailResponsible || 'Email non trouvé' }}<br />
                      <ng-container *ngIf="demandeDetail.phoneResponsible">Tél. :</ng-container>
                      {{ demandeDetail.phoneResponsible || 'Numéro de téléphone non trouvé' }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="uk-card uk-card-default uk-margin-top">
              <div class="uk-card-header uk-padding-small uk-background-muted">
                <div class="uk-width-expand">
                  <h3 class="uk-card-title uk-margin-remove-bottom uk-text-meta uk-text-uppercase uk-text-muted">
                    Planning
                  </h3>
                </div>
              </div>
              <div class="uk-card-body">
                <ng-container
                  *ngIf="demandeDetail && demandeDetail.planning && demandeDetail.planning[0]; else noPlanning"
                >
                  <table class="uk-table uk-table-divider">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>1/2 Journée</th>
                        <th>Horaires</th>
                        <th class="uk-table-expand">Lieu</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let creneau of demandeDetail.planning">
                        <td>{{ creneau.date }}</td>
                        <td>{{ creneau.journee }}</td>
                        <td>{{ creneau.horaire }}</td>
                        <td class="uk-table-expand uk-text-break">{{ creneau.site }}</td>
                      </tr>
                    </tbody>
                  </table>
                </ng-container>
                <ng-template #noPlanning>
                  <p>
                    Planning non trouvé
                  </p>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #displayErrorPage>
    <div class="uk-tile uk-tile-muted">
      <p class="uk-h4 uk-text-center">Une erreur est survenue lors du chargement</p>
    </div>
  </ng-template>
</ng-template>
